/* =============================================================================
   Eterno Grafiche — Configuratore Stampa fotografica incorniciata v2.0
   Due fasce formato: "base" (tavolo o parete, 5 aste a battente basso, niente
   passepartout) e "deluxe" (solo parete, 10 aste [basso+alto], passepartout
   disponibile). Colori/dimensioni aste e passepartout letti live dai
   data-attribute dello swatch (popolati da Liquid dai metaobject
   asta_configuratore / passepartout_configuratore) — nessuna mappa JS da
   tenere allineata al catalogo. Preview generata via CSS.
   ============================================================================= */

(function () {
  'use strict';

  const LS_KEY = 'eterno_inc_v2';
  const STEPS  = ['formato-asta', 'foto-checkout'];

  const MAX_FOTO_BYTES = 10 * 1024 * 1024;

  // Formato -> rapporto base/altezza + fascia. Fonte: db_stampe_incorniciate.csv
  const FORMAT_INFO = {
    '9×12 cm':  { ratio: 9 / 12,  gruppo: 'base' },
    '10×15 cm': { ratio: 10 / 15, gruppo: 'base' },
    '13×18 cm': { ratio: 13 / 18, gruppo: 'base' },
    '15×20 cm': { ratio: 15 / 20, gruppo: 'base' },
    '20×30 cm': { ratio: 20 / 30, gruppo: 'base' },
    '30×40 cm': { ratio: 30 / 40, gruppo: 'deluxe' },
    '30×45 cm': { ratio: 30 / 45, gruppo: 'deluxe' },
    '40×50 cm': { ratio: 40 / 50, gruppo: 'deluxe' },
    '40×60 cm': { ratio: 40 / 60, gruppo: 'deluxe' },
  };

  class EternoIncorniciata {

    constructor() {
      this.data = {
        formato:        null,
        orientamento:   'Verticale',
        gruppo:         null,
        montaggio:      'Tavolo',
        asta:           null,
        astaCategoria:  null,
        astaColoreStart:null,
        astaColoreEnd:  null,
        astaMm:         15,
        astaThumb:      null,
        prezzoBase:     0,
        variantId:      null,
        passepartout:   false,
        passColore:     null,
        passColoreHex:  null,
        passThumb:      null,
        passMm:         40,
        passVariantId:  null,
        passPrezzo:     0,
        hasFoto:        false,
        fotoDataUrl:    null,
        quantita:       1,
        cNote:          '',
        privacy:        false,
      };
      this.stepIndex   = 0;
      this._toastTimer = null;
      this.init();
    }

    get currentStep() { return STEPS[this.stepIndex]; }

    init() {
      const form = document.getElementById('ConfIncForm');
      if (!form) return;

      this.bindFormatoPills();
      this.bindOrientPills();
      this.bindMontaggioPills();
      this.bindAstaSwatches();
      this.bindPassepartout();
      this.bindFotoUpload();
      this.bindQty();
      this.bindCheckoutInputs();
      this.bindNav();

      // Pre-seleziona la prima asta/passepartout visibili (già marcate is-selected in Liquid)
      const firstAsta = document.querySelector('#cinc-asta-swatches .ctela-swatch.is-selected');
      if (firstAsta) this._applyAstaSelection(firstAsta, false);
      const firstPass = document.querySelector('#cinc-pass-swatches .ctela-swatch.is-selected');
      if (firstPass) this._applyPassSelection(firstPass, false);

      if (this.loadFromStorage()) this.restoreFormFields();

      this.updateUI();
      this.updateBreadcrumb();
      this.updatePreview();
      this.updatePriceHint();
    }

    // ---- Formato ------------------------------------------------------------

    bindFormatoPills() {
      document.querySelectorAll('#cinc-formato-pills-base .ctela-pill, #cinc-formato-pills-deluxe .ctela-pill').forEach(btn => {
        btn.addEventListener('click', () => this.onFormatoSelect(btn));
      });
    }

    onFormatoSelect(btn) {
      document.querySelectorAll('#cinc-formato-pills-base .ctela-pill, #cinc-formato-pills-deluxe .ctela-pill').forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      this.data.formato = btn.dataset.formato || null;
      this.data.gruppo  = btn.dataset.gruppo || null;

      this._applyGruppoVisibility();
      this.recomputeVariant();
      this.recomputePassepartout();
      this.updatePreview();
      this.updateBreadcrumb();
      this.updatePriceHint();
      this.saveToStorage();
    }

    _applyGruppoVisibility() {
      const isDeluxe = this.data.gruppo === 'deluxe';

      document.getElementById('cinc-montaggio-section')?.classList.toggle('conf-hidden', isDeluxe);
      // La sezione passepartout esiste solo nella fascia deluxe (i formati base
      // sono piccoli/poco profondi, niente passepartout). Dentro la fascia
      // deluxe la gallery è sempre presente ma abilitata/disabilitata dall'asta.
      document.getElementById('cinc-pass-section')?.classList.toggle('conf-hidden', !isDeluxe);
      if (!isDeluxe) {
        this.data.passepartout  = false;
        this.data.passColore    = null;
        this.data.passColoreHex = null;
        this.data.passThumb     = null;
      }

      // Aste a battente alto visibili solo in fascia deluxe
      document.querySelectorAll('#cinc-asta-swatches .ctela-swatch').forEach(b => {
        const isAlto = b.dataset.astaCategoria === 'alto';
        b.classList.toggle('conf-hidden', isAlto && !isDeluxe);
      });
      // Se l'asta attualmente selezionata non è più visibile, riseleziona la prima visibile
      const selected = document.querySelector('#cinc-asta-swatches .ctela-swatch.is-selected');
      if (!selected || selected.classList.contains('conf-hidden')) {
        const firstVisible = document.querySelector('#cinc-asta-swatches .ctela-swatch:not(.conf-hidden)');
        if (firstVisible) this._applyAstaSelection(firstVisible, true);
      } else {
        this._updatePassLock();
      }
    }

    // ---- Montaggio (property, nessun impatto prezzo) -------------------------

    bindMontaggioPills() {
      document.querySelectorAll('#cinc-montaggio-section .ctela-pill').forEach(btn => {
        btn.addEventListener('click', () => {
          document.querySelectorAll('#cinc-montaggio-section .ctela-pill').forEach(b => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');
          this.data.montaggio = btn.dataset.montaggio;
          this.updateBreadcrumb();
          this.saveToStorage();
        });
      });
    }

    // ---- Asta (property, nessun impatto prezzo) ------------------------------

    bindAstaSwatches() {
      document.querySelectorAll('#cinc-asta-swatches .ctela-swatch').forEach(btn => {
        btn.addEventListener('click', () => this._applyAstaSelection(btn, true));
      });
    }

    _applyAstaSelection(btn, persist) {
      document.querySelectorAll('#cinc-asta-swatches .ctela-swatch').forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      this.data.asta            = btn.dataset.asta || null;
      this.data.astaCategoria   = btn.dataset.astaCategoria || null;
      this.data.astaColoreStart = btn.dataset.coloreStart || null;
      this.data.astaColoreEnd   = btn.dataset.coloreEnd || null;
      this.data.astaMm          = parseFloat(btn.dataset.larghezzaMm) || 15;
      this.data.astaThumb       = btn.dataset.thumbUrl || null;
      // La disponibilità del passepartout dipende dal battente dell'asta scelta
      this._updatePassLock();
      if (persist) {
        this.recomputePassepartout();
        this.updatePreview();
        this.updateBreadcrumb();
        this.updatePriceHint();
        this.saveToStorage();
      }
    }

    // Passepartout in legno disponibile SOLO con aste a battente alto (≥20mm),
    // come Fotorecord (_updatePassLegnoState: locked se battente basso). La
    // gallery resta sempre visibile in fascia deluxe: qui la si abilita/blocca.
    _updatePassLock() {
      if (this.data.gruppo !== 'deluxe') return;
      const isAlto   = this.data.astaCategoria === 'alto';
      const locked   = !isAlto;
      const section  = document.getElementById('cinc-pass-section');
      const hint     = document.getElementById('cinc-pass-locked-hint');
      section?.classList.toggle('cinc-pass-locked', locked);
      if (hint) hint.style.display = locked ? '' : 'none';
      if (locked) {
        // forza "Nessuno" e azzera la selezione passepartout
        document.querySelectorAll('#cinc-pass-swatches .ctela-swatch').forEach(b =>
          b.classList.toggle('is-selected', b.dataset.passNone === '1'));
        this.data.passepartout  = false;
        this.data.passColore    = null;
        this.data.passColoreHex = null;
        this.data.passThumb     = null;
        this.recomputePassepartout();
      }
    }

    // ---- Passepartout ---------------------------------------------------------

    bindPassepartout() {
      document.querySelectorAll('#cinc-pass-swatches .ctela-swatch').forEach(btn => {
        btn.addEventListener('click', () => {
          // Bloccato quando la cornice scelta non lo consente (battente basso)
          if (document.getElementById('cinc-pass-section')?.classList.contains('cinc-pass-locked')) return;
          this._applyPassSelection(btn, true);
        });
      });
    }

    _applyPassSelection(btn, persist) {
      document.querySelectorAll('#cinc-pass-swatches .ctela-swatch').forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      if (btn.dataset.passNone === '1') {
        this.data.passepartout  = false;
        this.data.passColore    = null;
        this.data.passColoreHex = null;
        this.data.passThumb     = null;
      } else {
        this.data.passepartout  = true;
        this.data.passColore    = btn.dataset.passColore || null;
        this.data.passColoreHex = btn.dataset.coloreHex || null;
        this.data.passThumb     = btn.dataset.thumbUrl || null;
        this.data.passMm        = parseFloat(btn.dataset.larghezzaMm) || 40;
      }
      if (persist) {
        this.recomputePassepartout();
        this.updatePreview();
        this.updateBreadcrumb();
        this.updatePriceHint();
        this.saveToStorage();
      }
    }

    recomputePassepartout() {
      const d = this.data;
      const priceEl = document.getElementById('cinc-pass-price');
      if (!d.passepartout || !d.formato || !d.passColore) {
        d.passVariantId = null; d.passPrezzo = 0;
        if (priceEl) priceEl.textContent = '';
        return;
      }
      const key   = d.formato + ' / ' + d.passColore;
      const entry = window.EternoPassepartoutVariants && window.EternoPassepartoutVariants[key];
      d.passVariantId = entry ? entry.id : null;
      d.passPrezzo    = entry && typeof entry.price === 'number' ? entry.price : 0;
      if (priceEl) priceEl.textContent = d.passPrezzo ? '(+€' + d.passPrezzo.toFixed(2).replace('.', ',') + ')' : '';
    }

    // ---- Variante + prezzo dal formato selezionato ---------------------------

    recomputeVariant() {
      const d = this.data;
      if (!d.formato) { d.variantId = null; d.prezzoBase = 0; return; }
      const entry = window.EternoIncorniciataVariants && window.EternoIncorniciataVariants[d.formato];
      d.variantId  = entry ? entry.id : null;
      d.prezzoBase = entry && typeof entry.price === 'number' ? entry.price : 0;
    }

    // ---- Foto upload ---------------------------------------------------------

    bindFotoUpload() {
      // Due input file: quello del form (step 2, name="properties[Foto]") e uno
      // comodo nella colonna anteprima (step 1). Entrambi passano dallo stesso
      // handler; il file finisce SEMPRE anche nell'input del form (via
      // DataTransfer) così il carrello riceve la foto qualunque sia l'origine.
      const formInput = document.getElementById('cinc-foto-upload');
      ['cinc-foto-upload', 'cinc-foto-upload-preview'].forEach(id => {
        const input = document.getElementById(id);
        if (!input) return;
        input.addEventListener('change', () => {
          const file = input.files && input.files[0];
          if (!file || !file.type.startsWith('image/')) return;
          this._handleFotoFile(file, input === formInput);
        });
      });

      // Click sullo stage: se non c'è foto → apri il file picker; se c'è → zoom.
      const stage = document.getElementById('cinc-stage');
      if (stage) {
        const onStage = () => {
          if (this.data.hasFoto) this._openZoom();
          else document.getElementById('cinc-foto-upload-preview')?.click();
        };
        stage.addEventListener('click', onStage);
        stage.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onStage(); }
        });
      }
      document.getElementById('cinc-preview-upload-btn')?.addEventListener('click', () => {
        document.getElementById('cinc-foto-upload-preview')?.click();
      });

      // Lightbox: chiusura via backdrop / bottone / Esc
      const lb = document.getElementById('cinc-lightbox');
      lb?.addEventListener('click', e => {
        if (e.target.closest('[data-lightbox-close]')) this._closeZoom();
      });
      document.addEventListener('keydown', e => { if (e.key === 'Escape') this._closeZoom(); });
    }

    _handleFotoFile(file, fromFormInput) {
      // Assicura che il file sia anche nell'input del form (properties[Foto])
      const formInput = document.getElementById('cinc-foto-upload');
      if (formInput && !fromFormInput && typeof DataTransfer !== 'undefined') {
        try {
          const dt = new DataTransfer();
          dt.items.add(file);
          formInput.files = dt.files;
        } catch (_) { /* browser senza DataTransfer settabile: la foto resta solo in preview */ }
      }
      const reader = new FileReader();
      reader.onload = e => {
        this.data.fotoDataUrl = e.target.result;
        this.data.hasFoto     = true;
        // Auto-orientamento dalle proporzioni della foto (modificabile a mano)
        const probe = new Image();
        probe.onload = () => {
          if (probe.naturalWidth && probe.naturalHeight && probe.naturalWidth !== probe.naturalHeight) {
            this._setOrientamento(probe.naturalWidth > probe.naturalHeight ? 'Orizzontale' : 'Verticale', true);
          }
        };
        probe.src = e.target.result;
        this._applyFotoToPreview(e.target.result);

        const label = document.getElementById('cinc-upload-label');
        if (label) {
          label.classList.add('has-foto');
          const txt = document.getElementById('cinc-upload-label-text');
          if (txt) txt.textContent = 'Foto caricata — clicchi per cambiarla';
        }
        this._syncPreviewUploadState();
        this.updateBreadcrumb();
        this.saveToStorage();
      };
      reader.readAsDataURL(file);
    }

    _applyFotoToPreview(dataUrl) {
      const layer = document.getElementById('cinc-foto-layer');
      if (!layer) return;
      let img = document.getElementById('cinc-user-photo');
      if (!img) {
        img = document.createElement('img');
        img.id  = 'cinc-user-photo';
        img.alt = 'La foto caricata';
        layer.appendChild(img);
      }
      img.src = dataUrl;
      this._syncPreviewUploadState();
      this.updatePreview();
    }

    // Sincronizza gli inviti al caricamento in base allo stato foto e allo step.
    // Regola anti-ridondanza: mai più di UN invito "carica" visibile alla volta —
    // step 1 senza foto → pill sullo stage; step 2 senza foto → solo l'area
    // tratteggiata del form (pill nascosta); con foto → thumbnail nell'area
    // upload + "Cambia foto" sotto l'anteprima + zoom sullo stage.
    _syncPreviewUploadState() {
      const has     = this.data.hasFoto;
      const inStep2 = this.currentStep === 'foto-checkout';
      const stage   = document.getElementById('cinc-stage');
      const cta     = document.getElementById('cinc-stage-cta');
      const zoom    = document.getElementById('cinc-stage-zoom');
      const actions = document.getElementById('cinc-preview-actions');
      const btn     = document.getElementById('cinc-preview-upload-btn');
      const thumb   = document.getElementById('cinc-upload-thumb');
      if (stage) stage.classList.toggle('has-foto', has);
      if (cta)  cta.style.display  = (has || inStep2) ? 'none' : '';
      if (zoom) zoom.style.display = has ? '' : 'none';
      if (actions) actions.hidden = !has;
      if (btn) btn.textContent = has ? 'Cambi la foto' : 'Carichi la foto';
      if (thumb) {
        if (has && this.data.fotoDataUrl) { thumb.src = this.data.fotoDataUrl; thumb.hidden = false; }
        else { thumb.hidden = true; thumb.removeAttribute('src'); }
      }
    }

    _openZoom() {
      if (!this.data.hasFoto) return;
      const lb    = document.getElementById('cinc-lightbox');
      const stage = document.getElementById('cinc-lightbox-stage');
      const src   = document.getElementById('cinc-frame-box');
      if (!lb || !stage || !src) return;
      stage.innerHTML = '';
      const clone = src.cloneNode(true);
      clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      clone.removeAttribute('id');
      // nel lightbox non servono i CTA "carica/ingrandisci"
      clone.querySelectorAll('.tela-stage__cta, .tela-stage__zoom').forEach(el => el.remove());
      // Larghezza esplicita dello stage in base al rapporto del box, così il
      // riquadro incorniciato sta nel viewport per qualunque formato.
      const ratio = parseFloat(src.style.getPropertyValue('--ratio')) || 0.75;
      const w = Math.min(window.innerWidth * 0.88, window.innerHeight * 0.86 * ratio);
      stage.style.width = Math.round(w) + 'px';
      stage.appendChild(clone);
      lb.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    _closeZoom() {
      const lb = document.getElementById('cinc-lightbox');
      if (lb && !lb.hidden) { lb.hidden = true; document.body.style.overflow = ''; }
    }

    // ---- Quantità ------------------------------------------------------------

    bindQty() {
      const input = document.getElementById('ci-qty');
      if (!input) return;
      const clamp = () => {
        const v = Math.max(1, parseInt(input.value) || 1);
        input.value        = v;
        this.data.quantita = v;
        this.updatePriceHint();
        this.updateBreadcrumb();
        this.saveToStorage();
      };
      document.getElementById('cinc-qty-minus')?.addEventListener('click', () => {
        input.value = Math.max(1, parseInt(input.value || 1) - 1);
        clamp();
      });
      document.getElementById('cinc-qty-plus')?.addEventListener('click', () => {
        input.value = parseInt(input.value || 1) + 1;
        clamp();
      });
      input.addEventListener('change', clamp);
    }

    // ---- Checkout inputs -----------------------------------------------------

    bindCheckoutInputs() {
      const noteEl = document.getElementById('ci-note');
      if (noteEl) noteEl.addEventListener('input', () => {
        this.data.cNote = noteEl.value;
        this.updateLiveRecap();
        this.saveToStorage();
      });
      const privacyEl = document.getElementById('ci-privacy');
      if (privacyEl) privacyEl.addEventListener('change', () => {
        this.data.privacy = privacyEl.checked;
        this.saveToStorage();
      });
    }

    // ---- Navigation ----------------------------------------------------------

    bindNav() {
      document.getElementById('cinc-next')?.addEventListener('click', () => this.next());
      document.getElementById('cinc-prev')?.addEventListener('click', () => this.prev());
      document.getElementById('cinc-submit')?.addEventListener('click', () => this.addToCart());
    }

    next() {
      if (!this.validate()) return;
      if (this.stepIndex < STEPS.length - 1) {
        this.stepIndex++;
        this.updateUI();
        this.saveToStorage();
        this._scrollToConf();
      }
    }

    prev() {
      if (this.stepIndex > 0) {
        this.stepIndex--;
        this.clearError();
        this.updateUI();
        this.saveToStorage();
        this._scrollToConf();
      }
    }

    _scrollToConf() {
      const el = document.getElementById('EternoIncConf');
      if (!el) return;
      const headerEl = document.querySelector('sticky-header') || document.querySelector('.shopify-section-group-header-group');
      const headerH  = headerEl ? headerEl.offsetHeight : 0;
      const top      = el.getBoundingClientRect().top + window.scrollY - headerH - 16;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    // ---- Validation ------------------------------------------------------

    validate() {
      const s   = this.currentStep;
      const err = msg => { this.showError(msg); return false; };

      if (s === 'formato-asta') {
        if (!this.data.formato) return err('Selezioni un formato per proseguire.');
        if (!this.data.variantId) return err('Configurazione non disponibile — ricarichi la pagina e riprovi.');
        if (this.data.passepartout && !this.data.passVariantId) return err('Passepartout non disponibile — ricarichi la pagina e riprovi.');
        this.clearError(); return true;
      }

      if (s === 'foto-checkout') {
        if (!this.data.hasFoto) return err('Carichi la foto prima di proseguire.');

        const qty = parseInt(document.getElementById('ci-qty')?.value);
        if (!qty || qty < 1) return err('La quantità minima è 1.');
        this.data.quantita = qty;

        const privacy = document.getElementById('ci-privacy')?.checked;
        if (!privacy) return err('Per procedere è necessario accettare la Privacy Policy.');

        this.data.cNote     = document.getElementById('ci-note')?.value.trim() || '';
        this.data.privacy   = privacy;
        this.clearError(); return true;
      }

      this.clearError();
      return true;
    }

    // ---- Preview live --------------------------------------------------------

    // "30×40 cm" -> [30, 40] (accetta × o x). Fallback [30,40].
    _formatCm(formato) {
      const m = String(formato || '').match(/(\d+(?:[.,]\d+)?)\s*[×x]\s*(\d+(?:[.,]\d+)?)/i);
      if (!m) return [30, 40];
      return [parseFloat(m[1].replace(',', '.')), parseFloat(m[2].replace(',', '.'))];
    }

    // Dimensioni con orientamento applicato (swap se orizzontale)
    _orientedCm(formato) {
      let [b, a] = this._formatCm(formato);
      if (this.data.orientamento === 'Orizzontale') { const t = b; b = a; a = t; }
      return [b, a];
    }

    // ---- Orientamento (proprietà, stesso prezzo) -----------------------------

    bindOrientPills() {
      document.querySelectorAll('#cinc-orient-pills .ctela-pill').forEach(btn => {
        btn.addEventListener('click', () => this._setOrientamento(btn.dataset.orient, true));
      });
    }

    _setOrientamento(orient, persist) {
      if (orient !== 'Verticale' && orient !== 'Orizzontale') return;
      this.data.orientamento = orient;
      document.querySelectorAll('#cinc-orient-pills .ctela-pill').forEach(b =>
        b.classList.toggle('is-selected', b.dataset.orient === orient));
      this.updatePreview();
      this.updateBreadcrumb();
      this.updateLiveRecap();
      if (persist) this.saveToStorage();
    }

    updatePreview() {
      const { formato, astaColoreStart, astaColoreEnd, astaMm, astaThumb, passepartout, passColoreHex, passThumb } = this.data;

      const ph    = document.getElementById('cinc-preview-ph');
      const stage = document.getElementById('cinc-stage');
      const box   = document.getElementById('cinc-frame-box');
      const mat   = document.getElementById('cinc-mat');

      if (!formato) {
        ph?.classList.remove('conf-hidden');
        stage?.classList.add('conf-hidden');
        return;
      }

      ph?.classList.add('conf-hidden');
      stage?.classList.remove('conf-hidden');
      this._syncPreviewUploadState();

      // Geometria proporzionale (come Fotorecord: tutte le misure derivano dai
      // mm reali con un'unica scala). Le larghezze sono in cqw = % della
      // larghezza del box → cornice e mat si ridimensionano col formato.
      const [baseCm, altCm] = this._orientedCm(formato);
      const sezMm  = astaMm || 0;
      const passMm = (passepartout && passColoreHex) ? (this.data.passMm || 0) : 0;
      const totalW = baseCm * 10 + 2 * sezMm + 2 * passMm;
      const totalH = altCm * 10 + 2 * sezMm + 2 * passMm;

      if (box) {
        box.style.setProperty('--ratio', totalW && totalH ? (totalW / totalH) : ((FORMAT_INFO[formato] && FORMAT_INFO[formato].ratio) || 1));
        if (astaColoreStart && astaColoreEnd) {
          box.style.setProperty('--moulding-start', astaColoreStart);
          box.style.setProperty('--moulding-end', astaColoreEnd);
        }
        box.style.setProperty('--moulding-w', (totalW ? (sezMm / totalW * 100) : 4) + 'cqw');
        box.classList.toggle('has-real-image', !!astaThumb);
        if (astaThumb) {
          box.style.setProperty('--moulding-image', 'url("' + astaThumb + '")');
          // 9-slice come Fotorecord: il bordo cornice occupa larghezza_mm/200
          // della larghezza del render → slice% = mm/200*100 = mm/2. Campiona
          // i 4 angoli mitrati reali + i 4 lati, scarta il centro (watermark).
          box.style.setProperty('--moulding-slice', (astaMm / 2) + '%');
        }
      }

      if (mat) {
        if (passepartout && passColoreHex) {
          mat.style.setProperty('--gap-w', (totalW ? (passMm / totalW * 100) : 0) + 'cqw');
          mat.style.background = passColoreHex;
          mat.classList.toggle('has-real-image', !!passThumb);
          if (passThumb) {
            mat.style.setProperty('--mat-image', 'url("' + passThumb + '")');
            // Il render passepartout è una cornice-mat intera con angoli mitrati
            // (stessa convenzione delle aste): slice per-profilo = larghezza/200
            // = passMm/2, così i 4 angoli del mat combaciano; niente 'fill'.
            mat.style.setProperty('--mat-slice', (passMm / 2) + '%');
          }
        } else {
          mat.style.setProperty('--gap-w', '0cqw');
          mat.style.background = '#fff';
          mat.classList.remove('has-real-image');
        }
      }

      const hint = document.getElementById('cinc-preview-hint');
      if (hint) {
        hint.textContent = this.data.hasFoto ? '' : 'Carichi la foto per vedere l\'anteprima completa';
      }
    }

    // ---- Price hint ------------------------------------------------------

    updatePriceHint() {
      const el = document.getElementById('cinc-price-hint');
      if (!el) return;
      const { prezzoBase, passepartout, passPrezzo, quantita } = this.data;
      if (!prezzoBase) { el.textContent = ''; return; }
      const unit = prezzoBase + (passepartout ? passPrezzo : 0);
      const tot  = (unit * quantita).toFixed(2).replace('.', ',');
      const ppu  = unit.toFixed(2).replace('.', ',');
      el.textContent = `Totale: €${tot} (${quantita} pz × €${ppu}/pz)`;
    }

    // ---- Breadcrumb --------------------------------------------------------

    updateBreadcrumb() {
      const el = document.getElementById('cinc-breadcrumb');
      if (!el) return;
      const d = this.data;
      const items = [
        d.formato,
        d.formato && d.orientamento,
        d.gruppo === 'base' && d.montaggio && ('Da ' + d.montaggio.toLowerCase()),
        d.asta,
        d.passepartout && d.passColore && ('Passepartout ' + d.passColore),
        d.hasFoto && 'Foto caricata',
        d.quantita && d.quantita > 1 && (d.quantita + ' pz'),
      ].filter(Boolean);

      if (!items.length) { el.innerHTML = ''; return; }
      el.innerHTML = items.map((item, i) =>
        '<span class="conf-breadcrumb__item">' + this.esc(item) + '</span>' +
        (i < items.length - 1 ? '<span class="conf-breadcrumb__sep" aria-hidden="true">›</span>' : '')
      ).join('');
    }

    // ---- Live recap ------------------------------------------------------

    updateLiveRecap() {
      if (this.currentStep !== 'foto-checkout') return;
      const inner = document.getElementById('cinc-recap-inner');
      if (!inner) return;
      inner.innerHTML = this.buildRecapHTML();
    }

    buildRecapHTML() {
      const d    = this.data;
      const unit = d.prezzoBase + (d.passepartout ? d.passPrezzo : 0);
      const tot  = unit ? '€' + (unit * d.quantita).toFixed(2).replace('.', ',') +
                   ' (' + d.quantita + ' pz × €' + unit.toFixed(2).replace('.', ',') + '/pz)' : '—';
      let html = '';
      html += this.recapSection('Stampa incorniciata', [
        ['Formato',       d.formato],
        ['Orientamento',  d.orientamento],
        d.gruppo === 'base' && ['Montaggio', d.montaggio],
        ['Stile cornice', d.asta],
        d.passepartout && ['Passepartout', d.passColore],
        ['Quantità',      d.quantita + ' pz'],
        ['Totale',        tot],
      ].filter(Boolean));
      if (d.cNote) html += this.recapSection('Note', [['Note', d.cNote]]);
      return html;
    }

    recapSection(title, rows) {
      let dl = '<div class="conf-recap__section"><h3 class="conf-recap__heading">' + this.esc(title) + '</h3><dl class="conf-recap__list">';
      rows.forEach(([dt, dd]) => {
        if (!dd) return;
        dl += '<dt>' + this.esc(dt) + '</dt><dd>' + this.esc(String(dd)) + '</dd>';
      });
      return dl + '</dl></div>';
    }

    // ---- UI update -----------------------------------------------------------

    updateUI() {
      const current = this.currentStep;
      const total   = STEPS.length;
      const index   = this.stepIndex;

      document.querySelectorAll('.conf-step').forEach(el => {
        const active = el.dataset.step === current;
        el.classList.toggle('conf-step--active', active);
        el.style.display = active ? '' : 'none';
      });

      const pct  = Math.round(((index + 1) / total) * 100);
      const fill = document.getElementById('cinc-bar');
      if (fill) fill.style.width = pct + '%';
      this._setText('cinc-bar-curr', index + 1);
      this._setText('cinc-bar-tot',  total);

      const prevBtn   = document.getElementById('cinc-prev');
      const nextBtn   = document.getElementById('cinc-next');
      const submitBtn = document.getElementById('cinc-submit');
      const isLast    = index === total - 1;

      if (prevBtn) prevBtn.disabled = index === 0;
      nextBtn?.classList.toggle('conf-hidden',   isLast);
      submitBtn?.classList.toggle('conf-hidden', !isLast);

      this.clearError();
      this.updateBreadcrumb();
      this.updatePreview();
      if (isLast) {
        this.updateLiveRecap();
        this.updatePriceHint();
      }
    }

    // ---- Aggiungi al carrello --------------------------------------------

    async addToCart() {
      if (!this.validate()) return;

      const d = this.data;
      if (!d.variantId) {
        this.showError('Configurazione non disponibile — ricarichi la pagina e riprovi.');
        return;
      }

      const fotoInput = document.getElementById('cinc-foto-upload');
      const fotoFile  = fotoInput && fotoInput.files && fotoInput.files[0];
      if (fotoFile && fotoFile.size > MAX_FOTO_BYTES) {
        this.showError('La foto supera i 10 MB consentiti: scelga un file più leggero oppure la invii a ' +
          document.getElementById('EternoIncConf').dataset.email + ' dopo l\'ordine.');
        return;
      }

      const btn = document.getElementById('cinc-submit');
      if (btn) { btn.disabled = true; btn.textContent = 'Invio in corso…'; }
      this.clearError();

      // Il passepartout è un prodotto add-on separato: se selezionato viene
      // aggiunto al carrello via AJAX PRIMA di inviare il form principale
      // (che contiene il file foto e richiede una submit reale, non fetch).
      if (d.passepartout && d.passVariantId) {
        try {
          const res = await fetch('/cart/add.js', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body:    JSON.stringify({
              id: d.passVariantId,
              quantity: d.quantita,
              properties: { 'Per': d.formato + ' incorniciata' },
            }),
          });
          if (!res.ok) throw new Error('Errore aggiunta passepartout');
        } catch (e) {
          this.showError('Impossibile aggiungere il passepartout: ' + e.message);
          if (btn) { btn.disabled = false; btn.textContent = 'Aggiunga al carrello'; }
          return;
        }
      }

      const props = { 'Formato': d.formato, 'Orientamento': d.orientamento, 'Stile cornice': d.asta };
      if (d.gruppo === 'base') props['Montaggio'] = d.montaggio;
      if (d.passepartout) props['Passepartout'] = d.passColore;
      if (d.cNote) props['Note'] = d.cNote;

      const form = document.getElementById('shopify-cart-form-inc');
      form.querySelector('#scf-inc-variant-id').value = d.variantId;
      form.querySelector('#scf-inc-quantity').value   = d.quantita;
      const propsContainer = form.querySelector('#scf-inc-properties');
      propsContainer.innerHTML = '';
      Object.entries(props).forEach(([k, v]) => {
        const input = document.createElement('input');
        input.type  = 'hidden';
        input.name  = 'properties[' + k + ']';
        input.value = v;
        propsContainer.appendChild(input);
      });

      try { sessionStorage.removeItem(LS_KEY); } catch (_) {}
      form.submit();
    }

    // ---- sessionStorage ------------------------------------------------------

    saveToStorage() {
      try {
        const payload = {
          data:      Object.assign({}, this.data, { fotoDataUrl: null }),
          stepIndex: this.stepIndex,
        };
        sessionStorage.setItem(LS_KEY, JSON.stringify(payload));
      } catch (_) {}
    }

    loadFromStorage() {
      try {
        const raw = sessionStorage.getItem(LS_KEY);
        if (!raw) return false;
        const saved = JSON.parse(raw);
        if (!saved || !saved.data) return false;
        Object.assign(this.data, saved.data);
        this.stepIndex = Math.min(saved.stepIndex || 0, STEPS.length - 1);
        return true;
      } catch (_) { return false; }
    }

    restoreFormFields() {
      const d = this.data;
      const set = (id, val) => {
        if (val === null || val === undefined || val === '') return;
        const el = document.getElementById(id);
        if (el) el.value = val;
      };
      set('ci-qty',  d.quantita);
      set('ci-note', d.cNote);

      const cb = (id, val) => { const el = document.getElementById(id); if (el) el.checked = !!val; };
      cb('ci-privacy',   d.privacy);

      if (d.formato) {
        document.querySelectorAll('#cinc-formato-pills-base .ctela-pill, #cinc-formato-pills-deluxe .ctela-pill').forEach(b => {
          b.classList.toggle('is-selected', b.dataset.formato === d.formato);
        });
        this._applyGruppoVisibility();
      }

      document.querySelectorAll('#cinc-montaggio-section .ctela-pill').forEach(b => {
        b.classList.toggle('is-selected', b.dataset.montaggio === d.montaggio);
      });

      document.querySelectorAll('#cinc-orient-pills .ctela-pill').forEach(b => {
        b.classList.toggle('is-selected', b.dataset.orient === (d.orientamento || 'Verticale'));
      });

      document.querySelectorAll('#cinc-asta-swatches .ctela-swatch').forEach(b => {
        const match = b.dataset.asta === d.asta;
        b.classList.toggle('is-selected', match);
        if (match) {
          d.astaCategoria   = b.dataset.astaCategoria || null;
          d.astaColoreStart = b.dataset.coloreStart || null;
          d.astaColoreEnd   = b.dataset.coloreEnd || null;
          d.astaMm          = parseFloat(b.dataset.larghezzaMm) || 15;
          d.astaThumb       = b.dataset.thumbUrl || null;
        }
      });

      // Ripristina selezione passepartout (Nessuno vs colore); il lock in base
      // all'asta viene poi applicato da _updatePassLock (può forzare Nessuno).
      const passActive = d.passepartout && d.passColore;
      document.querySelectorAll('#cinc-pass-swatches .ctela-swatch').forEach(b => {
        const match = passActive ? (b.dataset.passColore === d.passColore) : (b.dataset.passNone === '1');
        b.classList.toggle('is-selected', match);
        if (match && !b.dataset.passNone) {
          d.passColoreHex = b.dataset.coloreHex || null;
          d.passThumb     = b.dataset.thumbUrl || null;
          d.passMm        = parseFloat(b.dataset.larghezzaMm) || 40;
        }
      });
      this._updatePassLock();

      this.recomputeVariant();
      this.recomputePassepartout();

      // La foto non sopravvive al reload (fotoDataUrl non persistito + input file
      // svuotato dal browser) → resetta lo stato per non mostrare "Foto caricata"
      // senza file reale.
      if (!d.fotoDataUrl) d.hasFoto = false;
      if (d.hasFoto) {
        const label = document.getElementById('cinc-upload-label');
        if (label) {
          label.classList.add('has-foto');
          const txt = document.getElementById('cinc-upload-label-text');
          if (txt) txt.textContent = 'Foto caricata — clicchi per cambiarla';
        }
      }
      this._syncPreviewUploadState();
    }

    // ---- Error / Toast ---------------------------------------------------

    showError(msg) {
      const el = document.getElementById('cinc-error');
      if (el) { el.textContent = msg; el.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
    }

    clearError() {
      const el = document.getElementById('cinc-error');
      if (el) el.textContent = '';
    }

    showToast(msg, duration = 3500) {
      const el = document.getElementById('cinc-toast');
      if (!el) return;
      el.textContent = msg;
      el.classList.add('conf-toast--visible');
      clearTimeout(this._toastTimer);
      this._toastTimer = setTimeout(() => el.classList.remove('conf-toast--visible'), duration);
    }

    // ---- Helpers -----------------------------------------------------------

    _setText(id, text) {
      const el = document.getElementById(id);
      if (el) el.textContent = text;
    }

    esc(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (document.getElementById('ConfIncForm')) new EternoIncorniciata();
  });

})();
